// SharedSafariSkeletonCard.js
import React from "react";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { Col, Row } from "react-bootstrap";

const SharedSafariSkeletonCard = () => {
    return (
        <div className="sharesafri-card">
            <div className="flotingdate">
                <div className="icons text-center">
                    <Skeleton height={20} width={30} />
                    <Skeleton height={20} width={30} />
                </div>
            </div>

            <div className="fixed-depart">
                <Skeleton height={20} width={100} />
            </div>

            <div className="shareimg">
                <Skeleton height={178} />
            </div>

            <div className="card_body">
                <div className="top_seats">
                    <Row className="safari justify-content-between pt-1" style={{ height: '32px' }}>
                        <Col className="safarinum d-flex gap-2 align-items-center">
                            <Skeleton height={20} width={50} />
                        </Col>
                        <Col className="safarinum d-flex gap-2 align-items-center justify-content-center">
                            <Skeleton height={20} width={50} />
                        </Col>
                    </Row>
                </div>

                <div className="titleDate">
                    <Skeleton height={16} width={`80%`} />
                    <Skeleton height={11} width={`60%`} />
                </div>

                <div className="footer_card row pb-2 pt-0 px-2 align-items-center">
                    <Col xs={6}>
                        <Skeleton height={20} width={80} />
                    </Col>
                    <Col xs={6} className="text-end">
                        <Skeleton height={27} width="90%" className="rounded-pill" />
                    </Col>
                </div>
            </div>
        </div>
    );
};

export default SharedSafariSkeletonCard;
